import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ComponentType} from '@angular/cdk/overlay';
import {CoreConfigurationService} from '../core-configuration.service';
import {Dialog} from '@angular/cdk/dialog';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  constructor(private router: Router, private dialog: Dialog, private coreConfiguration: CoreConfigurationService) {
  }

  openFromComponent<T>(contentComponent: ComponentType<T>, parameters: any, settings: Partial<PopupSettings> = new PopupSettings()) {
    let width = settings.width != null ? settings.width : settings.narrow ? '600px' : '800px';
    let height = settings.height != null ? settings.height : settings.dynamicHeight ? 'auto' : '60vh';
    const topPosition = settings.topPosition != null ? settings.topPosition : '10px';

    if (this.coreConfiguration.isMobile) {
      width = settings.width != null ? settings.width : '90%';
      height = settings.height != null ? settings.height : '90%';
    }

    if (settings.fullscreen) {
      width = '100%';
      height = '100%';
    }

    const dialogRef = this.dialog.open(contentComponent, {
      height: height,
      width: width,
      maxWidth: width,
      panelClass: 'popup-dialog-panel'
    });

    Object.keys(parameters).map((name) => {
      dialogRef.componentInstance[name] = parameters[name];
    });

    dialogRef.componentInstance['dialogRef'] = dialogRef;

    return dialogRef.closed;
  }

  navigate(routeParams: any[]) {
    return this.router.navigate([{
      outlets: {
        primary: routeParams,
        popup: null
      }
    }]);
  }
}

export class PopupSettings {
  dynamicHeight = false;
  fullscreen = false;
  narrow = false;
  width: string = null;
  height: string = null;
  topPosition: string = null;

  public constructor(init?: Partial<PopupSettings>) {
    Object.assign(this, init);
  }
}
